'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Time } from '@morpho-org/morpho-ts';
import { type ReactNode, useState } from 'react';
import { formatTimeseriesData } from '@/components/charts/helpers/highcharts';
import { CardDashboard } from '@/components/common/Card/CardDashboard';
import { useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';
import { useDashboardVaultHistory } from '../hooks/useDashboardUserHistory';
import DashboardHeroTotalDeposit from './DashboardHeroTotalDeposit';
interface DashboardHeroDepositsChartProps {
  chainIds: ChainId[];
  titleExtra: ReactNode;
}
const DashboardHeroDepositsChart = t0 => {
  const $ = _c(23);
  const {
    chainIds,
    titleExtra
  } = t0;
  const {
    address,
    isSelf
  } = useViewedAccountAddress();
  const {
    isDashboardExpanded,
    isDashboardHovered,
    isSmallDashboard
  } = useDashboardContext();
  const {
    positionHistory: isPositionHistoryEnabled
  } = useFeatureFlags();
  const [timeFrame, setTimeFrame] = useState("w");
  let t1;
  if ($[0] !== address || $[1] !== chainIds || $[2] !== isPositionHistoryEnabled || $[3] !== timeFrame) {
    t1 = {
      address,
      chainIds,
      timeFrame,
      enabled: isPositionHistoryEnabled
    };
    $[0] = address;
    $[1] = chainIds;
    $[2] = isPositionHistoryEnabled;
    $[3] = timeFrame;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    points,
    loading,
    isError
  } = useDashboardVaultHistory(t1);
  let t2;
  if ($[5] !== points) {
    t2 = formatTimeseriesData(points);
    $[5] = points;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const chartData = t2;
  const isFilterDisabled = !isPositionHistoryEnabled || loading;
  const t3 = isSelf ? "Your deposits" : "Deposits";
  let t4;
  if ($[7] !== chainIds) {
    t4 = <DashboardHeroTotalDeposit chainIds={chainIds} />;
    $[7] = chainIds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== chartData || $[10] !== isDashboardExpanded || $[11] !== isDashboardHovered || $[12] !== isError || $[13] !== isSmallDashboard || $[14] !== loading || $[15] !== timeFrame) {
    t5 = {
      isExpanded: isDashboardExpanded,
      isHovered: isDashboardHovered,
      isSmall: isSmallDashboard,
      isLoading: loading,
      data: chartData,
      error: isError,
      timeFrame,
      setTimeFrame
    };
    $[9] = chartData;
    $[10] = isDashboardExpanded;
    $[11] = isDashboardHovered;
    $[12] = isError;
    $[13] = isSmallDashboard;
    $[14] = loading;
    $[15] = timeFrame;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== isFilterDisabled || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== titleExtra) {
    t6 = <CardDashboard testId="dashboard-deposits-chart" title={t3} titleExtra={titleExtra} hideSizeButton={true} totalSlot={t4} isFilterDisabled={isFilterDisabled} state={t5} />;
    $[17] = isFilterDisabled;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = titleExtra;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default DashboardHeroDepositsChart;